import { render, staticRenderFns } from "./servicePackage.vue?vue&type=template&id=5c7be9ee&scoped=true"
import script from "./servicePackage.vue?vue&type=script&lang=js"
export * from "./servicePackage.vue?vue&type=script&lang=js"
import style0 from "./servicePackage.vue?vue&type=style&index=0&id=5c7be9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7be9ee",
  null
  
)

export default component.exports